import { FeatureFlags } from "flagged";

export const flags: FeatureFlags = {
  pollersAdd: false,
};
